import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=30cd1184"
import script from "./Shifts.vue?vue&type=script&lang=ts"
export * from "./Shifts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports